import React, { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "./store";
import { getCurrentUser, setToken } from "./features/auth/authSlice";
import AppRoutes from "./routes";
import { RingLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { ThemeProvider } from "./context/ThemeContext";
import { jwtDecode } from 'jwt-decode';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);

  // Token varsa her zaman kullanıcı bilgilerini güncelle
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && isAuthenticated) {
      // Her sayfa yenilemesinde kullanıcı bilgilerini API'den al
      dispatch(getCurrentUser());
    }
  }, [dispatch, isAuthenticated]);

  // Access token süresi dolmadan otomatik yenile
  useEffect(() => {
    const scheduleRefresh = () => {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');
      if (!token || !refreshToken) return;

      try {
        const decoded: any = jwtDecode(token);
        const expSeconds = decoded.exp ? decoded.exp : 0;
        const nowSeconds = Math.floor(Date.now() / 1000);
        const secondsUntilExpiry = expSeconds - nowSeconds;

        // 60 saniye önce yenile
        const refreshInMs = Math.max((secondsUntilExpiry - 60) * 1000, 0);
        if (refreshInMs === 0) return;

        const id = setTimeout(async () => {
          try {
            const res = await fetch((process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1') + '/auth/refresh', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ refresh_token: refreshToken })
            });
            if (res.ok) {
              const data = await res.json();
              if (data.access_token) {
                localStorage.setItem('token', data.access_token);
                dispatch(setToken(data.access_token));
              }
              if (data.refresh_token) {
                localStorage.setItem('refreshToken', data.refresh_token);
              }
              // Bir sonraki yenilemeyi planla
              scheduleRefresh();
            } else {
              // Yenileme başarısızsa token'ları temizleme işini interceptor yapacak
            }
          } catch (_) {
            // sessiz geç
          }
        }, refreshInMs);

        return () => clearTimeout(id);
      } catch (_) {
        // Geçersiz token ise bir şey yapma
      }
    };

    const cleanup = scheduleRefresh();
    return cleanup;
  }, [dispatch, isAuthenticated]);

  return (
    <ThemeProvider>
      {/* Eğer yükleme devam ediyorsa bir yükleme göstergesi göster */}
      {isAuthenticated && isLoading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="text-center">
            <RingLoader color="#007bff" size={60} />
            <p className="mt-3">{t("loading")}</p>
          </div>
        </div>
      ) : (
        <AppRoutes />
      )}
    </ThemeProvider>
  );
};

export default App;
